import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingNewsMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {String} param.data.category
   * @param {String} param.data.tag
   * @param {Number} param.data.pageNumber
   * @param {String} param.data.searchTerm
   * @param {Number} param.data.searchResultsCount
   */
  map({page, culture, data}) {
    const {category, tag, pageNumber = this._config.get('DEFAULT_PAGE_NUMBER'), searchTerm, searchResultsCount} = data
    const {TRACKING_TRANSLATIONS_BY_CULTURE} = this._config.get('tracking')
    const translations = TRACKING_TRANSLATIONS_BY_CULTURE[culture]
    const pageName = translations[`${page}_PAGE_NAME`]

    const trackingData = {
      list_page_num: pageNumber
    }

    if (searchResultsCount) trackingData.search_result_number = searchResultsCount
    if (searchTerm) {
      trackingData.filters = {
        keywords: searchTerm
      }
      trackingData.keywords = searchTerm
    }

    /* News section are the unique news related pages
    that do not share common tagging data */
    let isNewsSection = false

    switch (page) {
      case 'NEWS_CATEGORY':
        trackingData.page_name = category ? pageName.replace('%{category}', category) : translations.NEWS_HOME_PAGE_NAME
        if (category) trackingData.page_category_level2 = category
        break
      case 'NEWS_TAG':
        trackingData.page_name = pageName.replace('%{tag}', tag)
        trackingData.page_category_level3 = tag
        break
      case 'NEWS_SEARCH':
        trackingData.page_name = pageName
        break
      case 'NEWS_SECTION_TIPS':
      case 'NEWS_SECTION_TRENDS':
        isNewsSection = true
        break
      default:
        throw new Error(`No tracking data defined for page ${page}`)
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page: isNewsSection ? page : 'NEWS',
        culture
      })
      .map(trackingData)
  }
}
